import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import React from "react";
import { Subheading } from "src/components/base/heading";
import { ACL } from "src/components/acl";
import SINGLE_DEVICE_GROUP_CONTEXT from "src/context/internal/device-group";
import ReadOnlyRuleSets from "src/components/rulesets";

/**
 * The properties for {@link DeviceGroupOutboundACLs}
 */
export type DeviceGroupOutboundACLsProps = {};

/**
 * The view to display the Outbound ACLs of a device group
 */
function DeviceGroupOutboundACLs(props: DeviceGroupOutboundACLsProps) {
    const [t] = useTranslation("admin-device-group");

    const ctx = React.useContext(SINGLE_DEVICE_GROUP_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            <Subheading>{t("heading.add-new-acl")}</Subheading>
            <ACL
                key={"new-outbound"}
                onChange={ctx.reset}
                src={{ type: "DeviceGroup", value: ctx.deviceGroup }}
                startEditable={true}
            />

            <Subheading>{t("heading.existing-acls")}</Subheading>
            {ctx.deviceGroup.access_rules.outbound.map((acl) => (
                <ACL key={acl.uuid} src={acl.src} acl={acl} onChange={ctx.reset} />
            ))}

            <Subheading>{t("heading.rulesets")}</Subheading>
            {ctx.deviceGroup.rulesets.outbound.map((ruleset) => (
                <ReadOnlyRuleSets
                    key={ruleset.uuid}
                    name={ruleset.name}
                    description={ruleset.description}
                    rules={ruleset.rules}
                    sources={ruleset.src_or_dst}
                />
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/devicegroups/$deviceGroupId/_devicegroups/outbound-acls")({
    component: DeviceGroupOutboundACLs,
});
